import type { ExternalFilterDate, RootOperationsState } from '@/store/operations/model.ts';
import { isDefined } from '@/utils/assertions';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export const operationSlice = createSlice({
  name: 'operations',
  initialState: { rootDependentUIState: {} } as RootOperationsState,

  reducers: {
    dateRangeChanged: (
      state,
      {
        payload: { rootId, dateRange },
      }: PayloadAction<{ rootId: string; dateRange: ExternalFilterDate }>,
    ) => {
      if (isDefined(state.rootDependentUIState?.[rootId]?.externalFilters)) {
        state.rootDependentUIState[rootId].externalFilters.dateRange = dateRange;
      } else {
        state.rootDependentUIState[rootId] = {
          externalFilters: { dateRange },
          externalFiltersOperationFuture: { dateRange: undefined },
        };
      }
    },

    dateRangeOperationFutureChanged: (
      state,
      {
        payload: { rootId, dateRange },
      }: PayloadAction<{ rootId: string; dateRange: ExternalFilterDate }>,
    ) => {
      if (isDefined(state.rootDependentUIState?.[rootId]?.externalFilters)) {
        state.rootDependentUIState[rootId].externalFiltersOperationFuture.dateRange = dateRange;
      } else {
        state.rootDependentUIState[rootId] = {
          externalFilters: { dateRange: undefined },
          externalFiltersOperationFuture: { dateRange },
        };
      }
    },
  },

  selectors: {
    externalFilterDateRange: (state, rootId: string) =>
      state.rootDependentUIState?.[rootId]?.externalFilters?.dateRange,

    externalFilterDateRangeOperationFuture: (state, rootId: string) =>
      state.rootDependentUIState?.[rootId]?.externalFiltersOperationFuture?.dateRange,
  },
});

export const operationsActions = operationSlice.actions;

export const { externalFilterDateRange, externalFilterDateRangeOperationFuture } =
  operationSlice.selectors;
